const CALCULATOR_SECTION_TITLE_PREFIX = 'Данные калькулятора';

export interface PublicLeadCalculatorDisplay {
  pageLine: string | null;
  serviceLine: string | null;
  calculatorSectionTitle: string | null;
  sectionHeader: string;
  itemLines: readonly string[];
  summaryLines: readonly string[];
}

export function isStorageCalculatorItemLine(line: string): boolean {
  const trimmed = line.trim();
  return trimmed.includes('×') && trimmed.includes('≈');
}

export function partitionPublicLeadContextLines(
  contextLines: readonly string[],
): Pick<
  PublicLeadCalculatorDisplay,
  'sectionHeader' | 'itemLines' | 'summaryLines'
> {
  if (contextLines.length === 0) {
    return { sectionHeader: '', itemLines: [], summaryLines: [] };
  }

  const [sectionHeader, ...rest] = contextLines;
  const itemLines = rest.filter(isStorageCalculatorItemLine);
  const summaryLines = rest.filter((line) => !isStorageCalculatorItemLine(line));

  return { sectionHeader: sectionHeader.trim(), itemLines, summaryLines };
}

export function parsePublicLeadMessageIntro(
  message: string,
): Pick<
  PublicLeadCalculatorDisplay,
  'pageLine' | 'serviceLine' | 'calculatorSectionTitle'
> {
  const lines = message
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean);

  const pageLine =
    lines.find((line) => line.startsWith('Со страницы:')) ?? null;
  const serviceLine = lines.find((line) => line.startsWith('Услуга:')) ?? null;
  const calculatorSectionTitle =
    lines.find((line) => line.startsWith(CALCULATOR_SECTION_TITLE_PREFIX)) ??
    null;

  return { pageLine, serviceLine, calculatorSectionTitle };
}

export function buildPublicLeadCalculatorDisplay(
  message: string | null | undefined,
  contextLines: readonly string[] | null | undefined,
): PublicLeadCalculatorDisplay | null {
  if (!contextLines?.length) {
    return null;
  }

  const intro = message?.trim()
    ? parsePublicLeadMessageIntro(message)
    : { pageLine: null, serviceLine: null, calculatorSectionTitle: null };

  return {
    ...intro,
    ...partitionPublicLeadContextLines(contextLines),
  };
}
